export default "__VITE_ASSET__47P0d1gC__"